import React, { useEffect, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import FNOLLossLocation from '../../../capabilities-react/gw-capability-fnol-common-react/components/LossLocation/LossLocation';
import metadata from './WherePage.metadata.json5';
import styles from './WherePage.module.scss';
import messages from '../../../capabilities-react/gw-capability-fnol-common-react/FNOL.messages';
import Claim from '../../../capabilities-react/gw-capability-fnol-common-react/models/Claim';

function SasriaFNOLWherePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        authHeader
    } = props;
    const translator = useContext(TranslatorContext);
    const [isLoading, setIsLoading] = useState(false);
    const [catastropheList, updateCatastropheList] = useState([]);
    const [directCatList, setDirCatList] = useState([]);
    const [catCode, setCatCode] = useState(null);
    const history = useHistory();
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation
    } = useValidation('SasriaFNOLWherePage');

    const writeValue = useCallback((value, path) => {
        _.set(claimVM.value, path, value);
        if (path === 'catastrophe_ext') {
            _.set(claimVM.value, 'catastrophe_ext', value);
            setCatCode(value);
            const catValue = directCatList.find((cat) => {
                return cat.code === value;
            });
            _.set(claimVM.value, 'catastropheDetails_Ext', catValue);
        }
        if (path === 'description') {
            _.set(claimVM.value, 'description', value);
        }
        updateWizardData(claimVM);
    }, [claimVM, directCatList, updateWizardData]);


    const overrideProps = {
        lossLocationComponent: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData
        },
        wherePageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(messages.createDraftClaim)
        },
        subPerils_EXT: {
            visible: _.get(claimVM.value, 'perils_EXT', false)
        },
        catastrophe_EXT: {
            availableValues: catastropheList,
            value: catCode
        }
    };
    const { FNOLService } = useDependencies('FNOLService');

    const onPrevious = useCallback(() => {
        const onPreviousModalProps = {
            title: commonMessages.wantToJump,
            message: commonMessages.baseFNOLPreviousWarning,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yes,
            cancelButtonText: commonMessages.close
        };
        ModalNextProvider.showConfirm(onPreviousModalProps).then(
            (results) => {
                if (results === 'cancel') {
                    return _.stubFalse();
                }
                return history.push({
                    pathname: '/fnol-select-policy',
                    state: {
                        redirectPath: '/claims'
                    }
                });
            }, _.stubFalse
        );
    }, [history]);

    const onNext = useCallback(() => {
        // const miscellaneous = claimVM.lossCause.value.code === 'otherobjcoll';
        const policyNumber = _.get(claimVM, 'policy.policyNumber.value');
        const isClaimNumberAvailable = _.get(claimVM, 'claimNumber.value');
        // if (isClaimNumberAvailable) {
        //     if (miscellaneous) {
        //         return redirectContactAgent();
        //     }
        //     return incidentPageHandling();
        // }
        setIsLoading(true);
        // return FNOLService.getFNOLDetails(policyNumber, claimVM.value, authHeader)
        if (catCode != null) {
            return FNOLService.validateCatastropheDetails_EXT(claimVM.value, authHeader)
                .then((response) => {
                    if (!response.isCatastropheValid) {
                        ModalNextProvider.showAlert({
                            title: 'Catastrophe Invalid',
                            message: messages.catastropheInvalid,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok
                        }).then(() => {
                            _.set(claimVM.value, 'catastrophe_ext', null);
                            _.set(claimVM.value, 'catastropheDetails_Ext', null);
                            setCatCode(null);
                        })
                            .catch(_.noop);
                        return false;
                    }
                    return claimVM;
                }).finally(() => {
                    setIsLoading(false);
                });
        }
        return claimVM;
        // return FNOLService.getFNOLDetails_EXT(claimVM.value, authHeader)
        //     .then((response) => {
        //         claimVM.value = new Claim(response);
        //         // if (miscellaneous) {
        //         //     return redirectContactAgent();
        //         // }
        //         // return incidentPageHandling();
        //         const claimNumber = _.get(claimVM.value, 'claimNumber');
        //         const { redirectPath } = state;
        //         return history.push({
        //             pathname: `/confirmation/${claimNumber}`,
        //             state: {
        //                 redirectPath: redirectPath
        //             }
        //         });
        //     })
        //     .catch((err) => {
        //         // ModalNextProvider.showAlert({
        //         //     title: messages.paCreateDraftErrorTitle,
        //         //     message: messages.paCreateDraftErrorMessage,
        //         //     status: 'error',
        //         //     icon: 'mi-error-outline',
        //         //     confirmButtonText: commonMessages.ok
        //         // }).catch(_.noop);
        //         // return false;
        //         return history.push('/claims');
        //     })
        //     .finally(() => {
        //         setIsLoading(false);
        //     });
    }, [FNOLService, authHeader, catCode, claimVM]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            losslocationcomponent: FNOLLossLocation
        },
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    const validateClaimStatus = useCallback(() => {
        const { claimStatus } = state;
        return !_.isNil(claimStatus);
    }, [state]);

    const processCatastropheData = useCallback((response) => {
        const catastropheDataList = [];
        response.forEach((element) => {
            const catastropheData = {
                displayName: element.displayName,
                id: element.code
            };
            catastropheDataList.push(catastropheData);
        });
        return catastropheDataList;
    }, []);

    const getCatastropheList = useCallback(() => {
        FNOLService.fetchCatastropheList_EXT(authHeader).then((response) => {
            setDirCatList(response);
            updateCatastropheList(processCatastropheData(response));
        });
    }, [FNOLService, authHeader, processCatastropheData]);

    useEffect(() => {
        registerInitialComponentValidation(validateClaimStatus);
    }, [validateClaimStatus, registerInitialComponentValidation]);

    useEffect(() => {
        getCatastropheList();
    }, [getCatastropheList]);

    return (
        <WizardPage
            onNext={onNext}
            showPrevious={false}
            cancelLabel={translator(messages.fnolCancel)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onValueChange={writeValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
// FNOLWherePage.propTypes = wizardProps;
// export default withRouter(FNOLWherePage);


SasriaFNOLWherePage.propTypes = wizardProps;
SasriaFNOLWherePage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};
export default withRouter(withAuthenticationContext(SasriaFNOLWherePage));
